import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const money = (n) => `$${Number(n || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const disp = (r, c) => (c.money ? money(r[c.key]) : (r[c.key] == null ? "" : String(r[c.key])));

// XLSX keeps money columns as raw numbers so totals/sorting work in Excel
export function exportXLSX(filename, columns, rows) {
  const header = columns.map((c) => c.label);
  const body = rows.map((r) => columns.map((c) => (c.money ? Number(r[c.key] || 0) : (r[c.key] == null ? "" : r[c.key]))));
  const ws = XLSX.utils.aoa_to_sheet([header, ...body]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}

export function exportPDF(title, columns, rows) {
  const doc = new jsPDF({ orientation: columns.length > 5 ? "landscape" : "portrait" });
  doc.setFontSize(14); doc.text(title, 14, 16);
  autoTable(doc, {
    startY: 22,
    head: [columns.map((c) => c.label)],
    body: rows.map((r) => columns.map((c) => disp(r, c))),
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [18, 58, 99] },
    columnStyles: columns.reduce((a, c, i) => (c.money ? { ...a, [i]: { halign: "right" } } : a), {}),
  });
  doc.save(`${title.replace(/[^\w]+/g, "_")}.pdf`);
}

export function printReport(title, columns, rows) {
  const head = columns.map((c) => `<th style="text-align:${c.money ? "right" : "left"}">${c.label}</th>`).join("");
  const body = rows.map((r) => `<tr>${columns.map((c) => `<td style="text-align:${c.money ? "right" : "left"}">${disp(r, c)}</td>`).join("")}</tr>`).join("");
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>${title}</title><style>body{font-family:Arial,Helvetica,sans-serif;padding:24px;color:#111}h1{font-size:18px;margin:0 0 12px}table{width:100%;border-collapse:collapse;font-size:12px}th,td{border:1px solid #ccc;padding:5px 8px}th{background:#123a63;color:#fff}tr:nth-child(even) td{background:#f6f9fc}</style></head><body><h1>${title}</h1><table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`);
  w.document.close(); w.focus(); setTimeout(() => { try { w.print(); } catch (e) { /* noop */ } }, 300);
}
